import eventos from "./eventos";
import { initVMasker, inserirOptionsEstados } from "./controllers";

initVMasker()
document.addEventListener("DOMContentLoaded", eventos);
inserirOptionsEstados()